module.exports = __webpack_public_path__ + "img/process_large.07ff8bcb.png";